import React, { useState, useEffect } from "react";
import "./../styles/Maintenance.css";

const Maintenance = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [animating, setAnimating] = useState(false);
  const [theme, setTheme] = useState("light");

  // Detectar el tema del sistema al cargar la página
  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    if (mediaQuery.matches) {
      setTheme("dark");
      document.body.classList.add("dark-theme");
    } else {
      setTheme("light");
      document.body.classList.remove("dark-theme");
    }

    const themeChangeHandler = (e) => {
      if (e.matches) {
        setTheme("dark");
        document.body.classList.add("dark-theme");
      } else {
        setTheme("light");
        document.body.classList.remove("dark-theme");
      }
    };

    mediaQuery.addEventListener("change", themeChangeHandler);

    return () => {
      mediaQuery.removeEventListener("change", themeChangeHandler);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAnimating(true);  // Inicia la animación

    // Realizar la solicitud POST al backend Flask
    try {
      const response = await fetch("https://api-portfolio-744p.onrender.com/api/submit-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }), // Enviar el correo en el cuerpo de la solicitud
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        alert("Error al enviar el correo. Inténtalo de nuevo.");
      }
    } catch (error) {
      alert("Error de conexión. Inténtalo de nuevo.");
    } finally {
      setAnimating(false);
    }
  };

  return (
    <div className="maintenance-container">
      <div className="loader"></div> {/* Spinner */}
      <h1>Me encuentro realizando mantenimiento👨🏻‍💻</h1>
      <p>Por favor, volvé intentar más tarde.</p>
      <p>Si lo deseas podes dejarme tu email, te notificaré cuando la página este lista:</p>

      {submitted ? (
        <div className="thank-you">
          <img
            src="https://img.icons8.com/ios-filled/50/28a745/checkmark.png" 
            alt="Success"
          />
          <p>¡Gracias por tu interés! <br/>Terminaré lo más pronto posible🙏🏼</p>
        </div>
      ) : (
        <form className="email-form" onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Tu correo"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button
            type="submit"
            className={animating ? "submit-btn animating" : "submit-btn"}
          >
            {animating ? "" : "Notificarme"}
          </button>
        </form>
      )}
    </div>
  );
};

export default Maintenance;